import { render } from "./Loading.vue?vue&type=template&id=28e3b1b7&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=28e3b1b7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28e3b1b7"

export default script